import Link from 'next/link'
import { TrackedBillsProps } from '..'

import { BillCard } from '@/components/legislative-tracker/BillCard'
import { Button } from '@/components/ui/button'

export const BillsListing = ({ bills, allBillTopics }: TrackedBillsProps) => {
  return (
    <>
      <div className="flex flex-col gap-4 [&>.bill-card]:w-full [&>.bill-card]:max-w-full">
        {bills.map((bill) => (
          <BillCard key={bill.id} bill={bill} allBillTopics={allBillTopics} size="small" />
        ))}
      </div>
      <div className="mx-auto pt-2 pb-1">
        <Button variant="outline" size="small" className="w-full" asChild>
          <Link href={'/legislative-tracker'}>Explore more bills</Link>
        </Button>
      </div>
    </>
  )
}
